import { Box, Flex, Text } from "@chakra-ui/react";

export function OrderSummary({
  totalValue,
  totalUnits,
  peopleCount,
  readyTotal,
  readyComplete,
  pendingLabels,
  unavailableLabels,
}) {
  const totalValueLabel = totalValue.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
  const allComplete = readyTotal > 0 && readyComplete === readyTotal;
  const hasGaps = pendingLabels.length > 0 || unavailableLabels.length > 0;
  const valuePerPerson = peopleCount > 0 ? totalValue / peopleCount : null;
  const valuePerPersonLabel =
    valuePerPerson != null
      ? valuePerPerson.toLocaleString("pt-br", { style: "currency", currency: "BRL" })
      : null;

  return (
    <Box
      bg="rgba(0,74,51,0.04)"
      border="1px solid rgba(0,74,51,0.1)"
      borderRadius="14px"
      p={{ base: "14px", md: "16px" }}
    >
      <Flex justify="space-between" align="flex-end" gap="14px" flexWrap="wrap">
        <Box>
          {valuePerPersonLabel ? (
            <>
              <Text fontSize="11px" fontWeight="700" color="gray.500" textTransform="uppercase" letterSpacing="0.04em" mb="2px">
                Valor por pessoa
              </Text>
              <Text fontSize={{ base: "24px", md: "28px" }} fontWeight="900" color="#004a33" lineHeight="1">
                {valuePerPersonLabel}
              </Text>
              <Text fontSize="12px" color="gray.500" fontWeight="600" mt="3px">
                Total estimado: {totalValueLabel} ({peopleCount} pessoas)
              </Text>
            </>
          ) : (
            <>
              <Text fontSize="11px" fontWeight="700" color="gray.500" textTransform="uppercase" letterSpacing="0.04em" mb="2px">
                Total estimado do pedido
              </Text>
              <Text fontSize={{ base: "22px", md: "26px" }} fontWeight="900" color="#004a33" lineHeight="1">
                {totalValueLabel}
              </Text>
            </>
          )}
        </Box>

        <Flex gap="20px">
          <Box textAlign="right">
            <Text fontSize="10px" fontWeight="700" color="gray.500" textTransform="uppercase" letterSpacing="0.04em">
              Itens
            </Text>
            <Text fontSize="16px" fontWeight="800" color="#004a33">
              {totalUnits}
            </Text>
          </Box>

          {readyTotal > 0 && (
            <Box textAlign="right">
              <Text fontSize="10px" fontWeight="700" color="gray.500" textTransform="uppercase" letterSpacing="0.04em">
                Categorias completas
              </Text>
              <Text fontSize="16px" fontWeight="800" color={allComplete ? "#2f9e44" : "#004a33"}>
                {readyComplete}/{readyTotal}
              </Text>
            </Box>
          )}
        </Flex>
      </Flex>

      {hasGaps && (
        <Text fontSize="11px" color="gray.500" mt="10px">
          {pendingLabels.length > 0 && `Ainda sem produtos cadastrados pra ${pendingLabels.join(", ")}. `}
          {unavailableLabels.length > 0 && `Sem estoque no momento pra ${unavailableLabels.join(", ")}.`}
        </Text>
      )}
    </Box>
  );
}
